import { useCountUp, useInView } from "@/hooks/useReveal";

interface AnimatedCounterProps {
  value: number;
  suffix?: string;
  prefix?: string;
  decimals?: number;
  className?: string;
}

export default function AnimatedCounter({
  value,
  suffix = "",
  prefix = "",
  decimals,
  className = "",
}: AnimatedCounterProps) {
  const { ref, inView } = useInView<HTMLSpanElement>(0.4);
  const animated = useCountUp(value, inView);
  const places = decimals ?? (Number.isInteger(value) ? 0 : 1);

  return (
    <span ref={ref} className={className}>
      {prefix}
      {animated.toFixed(places)}
      {suffix}
    </span>
  );
}